import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { calculateUpdatedTime } from '../../attendance/shift-time';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';


@Component({
  selector: 'app-employee-payroll-salary-detail',
  templateUrl: './employee-payroll-salary-detail.component.html',
  styleUrls: ['./employee-payroll-salary-detail.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, LoaderComponent],
  providers: [DatePipe],
})
export class EmployeePayrollSalaryDetailComponent implements OnInit {
  public selected_user_id: any = [];
  public salary_month: any = [];
  public salary_month_int: any = [];
  public salary_month_year: any = [];
  public salary_id: any = [];
  public user_detail: any = [];
  public leaves_list: any = [];
  public active_loan: any = [];
  public active_loan_id: any = null;
  public active_loan_installment_amount: any = null;
  public inputLoanPaymemnt: any;
  public isSalaryGenrated = false;
  public attandance_list: any = [];
  public salary_detail: any = [];
  public paidLeaves: any[] = [];
  public paidLeavesHalf: any[] = [];
  public unpaidLeaves: any[] = [];
  public unpaidLeavesHalf: any[] = [];
  public inputAdvancePayment: any;
  public inputCommpensationAmount: any;
  public inputOtherPayemtn: any;
  public inputTaxDetails: any;
  public genratedSalayDetails: Record<string, any> = {}
  public showSpinner = true;
  user_detail_openSalary: any;
  user: any;
  selectedMode: any;
  userInfo: any;
  colormode: any;
  latestShiftoffday: any;
  status: any;
  unpaid_short_leave_totalHours = 0;
  unpaid_short_leave_numberOfDays = 0;
  paid_short_leave_totalHours = 0;
  paid_short_leave_numberOfDays = 0;
  unpaid_short_leave_salary_deduction = 0;
  constructor(
    public _location: Location,
    public activated_route: ActivatedRoute,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    public datepipe: DatePipe,
    public router: Router
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail_mode();
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type != "Admin" && user_role.role_type != "Admin_AND_Team_Lead") {
      this.router.navigate(['/dashboard-1']);
    }
  }

  ngOnInit(): void {
    this.selected_user_id = this.activated_route.snapshot.paramMap.get('user_id')
    this.salary_month = this.activated_route.snapshot.paramMap.get('mont_char')
    this.salary_month_int = this.activated_route.snapshot.paramMap.get('mont_int')
    this.salary_month_year = this.activated_route.snapshot.paramMap.get('month_year')
    this.salary_id = this.activated_route.snapshot.paramMap.get('salary_id')

    this.getSalaryDetails();
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }

  getSalaryDetails() {
    const date = new Date(this.salary_month_year + "-" + parseInt(this.salary_month_int) + "-01");
    const startdate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd');
    const endDate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth() + 1, 0), 'yyyy-MM-dd');
    this.dashboardService.getSalaryDetail(this.selected_user_id,
      this.salary_id,
      startdate,
      endDate).then((value) => {
        this.showSpinner = false;
        this.salary_detail = value.data.salary_detail[0]
        this.user_detail = value.data.user[0]
        this.user_detail_openSalary = value.data.user[0].open_salary
        this.leaves_list = value.data.leaves
        this.active_loan = value.data.active_loan
        if (this.active_loan != null) {
          this.active_loan_id = this.active_loan.id
          this.active_loan_installment_amount = this.active_loan.installment
        }
        const temp_array: any[] = []
        let indexCount = 0
        let lastDate = ""
        let totalHours = 0
        let singleArray: any[] = []
        let typeArr = value.data.monthly_attandance.attendance
        typeArr.forEach((x: any) => {
          if (indexCount == 0) {
            totalHours += x.total_hours
            lastDate = x.date
            singleArray.push(x)
          } else {
            if (x.date == lastDate) {
              totalHours += x.total_hours
              singleArray.push(x)
              if (indexCount == typeArr.length - 1) {
                var obj = { "total_hours": totalHours, "data": singleArray }
                temp_array.push(obj)
              }
            } else {
              var obj = { "total_hours": totalHours, "data": singleArray }
              temp_array.push(obj)
              singleArray = []
              lastDate = x.date
              totalHours = 0
              totalHours = x.total_hours
              singleArray.push(x)
              if (indexCount == typeArr.length - 1) {
                var obj = { "total_hours": totalHours, "data": singleArray }
                temp_array.push(obj)
              }
            }
          }

          indexCount++
        });
        typeArr = temp_array


        this.attandance_list = temp_array

        this.inputAdvancePayment = (document.getElementById("advance_payment") as HTMLInputElement)
        this.inputLoanPaymemnt = (document.getElementById("loan_amount") as HTMLInputElement)
        this.inputCommpensationAmount = (document.getElementById("compensation_amount") as HTMLInputElement)
        this.inputOtherPayemtn = (document.getElementById("other_duduction") as HTMLInputElement)
        this.inputTaxDetails = (document.getElementById("tax_amount") as HTMLInputElement)
        this.inputAdvancePayment.value = this.salary_detail.advance_payment
        this.inputCommpensationAmount.value = this.salary_detail.compensation_amount
        this.inputOtherPayemtn.value = this.salary_detail.other_deduction
        this.inputTaxDetails.value = this.salary_detail.tax
        if (this.active_loan != null || this.salary_detail.loan_deduction_amount != null) {
          if (this.active_loan == null) {
            this.inputLoanPaymemnt.value = this.salary_detail.loan_deduction_amount
            this.active_loan_id = this.salary_detail.loan_id
            this.active_loan_installment_amount = this.salary_detail.loan_deduction_amount
          } else {
            this.inputLoanPaymemnt.value = this.active_loan_installment_amount
          }
          this.inputLoanPaymemnt.readOnly = true
        }
        if (this.salary_detail.status != "draft") {
          this.inputAdvancePayment.readOnly = true
          this.inputCommpensationAmount.readOnly = true
          this.inputOtherPayemtn.readOnly = true
          this.inputTaxDetails.readOnly = true
        }
      });
  }
  saveGenratedSalary() {
    this.showSpinner = true;
    const dt = this.datepipe.transform(Date.now(), 'yyyy-MM-dd HH:mm:ss')
    const postBody = {
      month_char: this.salary_detail.month_char || '',
      month_year: this.salary_detail.month_year || '',
      month_int: this.salary_detail.month_int || '',
      user_id: this.selected_user_id || '',
      status: "approved",
      id: this.salary_id || 0,
      released_salary: this.salary_detail.released_salary,
      tax: this.salary_detail.tax,
      short_hours: this.salary_detail.short_hours,
      short_hours_amount: this.salary_detail.short_hours_amount,
      late_check_in: this.salary_detail.late_check_in,
      late_check_in_amount: this.salary_detail.late_check_in_amount,
      unpaid_leaves: this.salary_detail.unpaid_leaves,
      unpaid_leaves_amount: this.salary_detail.unpaid_leaves_amount,
      absents: this.salary_detail.absents,
      absents_amount: this.salary_detail.absents_amount,
      advance_payment: this.salary_detail.advance_payment,
      overtime_hours: this.salary_detail.overtime_hours,
      overtime_amount: this.salary_detail.overtime_amount,
      other_deduction: this.salary_detail.other_deduction,
      basic_salary: this.salary_detail.basic_salary,
      compensation_amount: this.salary_detail.compensation_amount,
      employee_code: this.user_detail.attendance_user_id,
      joining_date: this.user_detail.joining_date,
      cnic: this.user_detail.cnic,
      employeement_status: this.user_detail.employeement_status,
      salary_released_date: dt,
      total_deduction: this.salary_detail.total_deduction,
      paid_leaves: this.paidLeaves.length,
      loan_id: this.active_loan_id,
      loan_deduction_amount: this.active_loan_installment_amount,
      total_worked_hours: this.salary_detail.total_worked_hours
    }
    this.updateSalaryAPICall(postBody)
  }

  setSalaryOnHold() {
    this.showSpinner = true;
    const postBody = {
      month_char: this.salary_detail.month_char || '',
      month_year: this.salary_detail.month_year || '',
      month_int: this.salary_detail.month_int || '',
      user_id: this.selected_user_id || '',
      total_worked_hours: this.salary_detail.total_worked_hours || '',
      status: "onhold",
      id: this.salary_id || 0
    }
    this.updateSalaryAPICall(postBody)
  }
  setSalaryReleased() {
    this.showSpinner = true;
    const dt = this.datepipe.transform(Date.now(), 'yyyy-MM-dd HH:mm:ss')
    const postBody = {
      month_char: this.salary_detail.month_char || '',
      month_year: this.salary_detail.month_year || '',
      month_int: this.salary_detail.month_int || '',
      user_id: this.selected_user_id || '',
      total_worked_hours: this.salary_detail.total_worked_hours || '',
      status: "released",
      id: this.salary_id || 0,
      salary_released_date: dt
    }
    this.updateSalaryAPICall(postBody)
  }
  setSalaryBackToDraft() {
    this.showSpinner = true;
    const postBody = {

      month_char: this.salary_detail.month_char || '',
      month_year: this.salary_detail.month_year || '',
      month_int: this.salary_detail.month_int || '',
      user_id: this.selected_user_id || '',
      total_worked_hours: this.salary_detail.total_worked_hours || '',
      status: "draft",
      id: this.salary_id || 0,
      loan_id: this.active_loan_id
    }


    const loanID = {
      loan_id: this.active_loan_id
    }


    this.updateSalaryAPICall(postBody)
    this.updateloancounter(loanID)

  }


  updateloancounter(loanID: any) {
    if (loanID != null || loanID != '' || loanID) {
      this.dashboardService.saveGenratedSalary(loanID).then((value) => {
        this.showSpinner = false;

      });

    }






  }








  setSalaryApproved() {
    this.showSpinner = true;

    const postBody = {
      month_char: this.salary_detail.month_char || '',
      month_year: this.salary_detail.month_year || '',
      month_int: this.salary_detail.month_int || '',
      user_id: this.selected_user_id || '',
      status: "approved",
      id: this.salary_id || 0
    }
    this.updateSalaryAPICall(postBody)
  }
  updateSalaryAPICall(postBody: any) {
    this.dashboardService.saveGenratedSalary(postBody).then((value) => {
      this.showSpinner = false;
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Application Submitted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this._location.back();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }
  setUpLeaves() {
    this.leaves_list.forEach((x: any) => {
      if (x.status == "approved") {
        if (x.leave_payment_status == "paid") {
          if ((x.start_date != null || x.start_date.length > 0) && (x.end_date != null || x.end_date.length > 0)) {
            var dtt = new Date(x.start_date)
            var day = dtt.getDate()
            var totalDays = this.calculateDiff(x.start_date, x.end_date)
            for (let i = 0; i < totalDays; i++) {
              var str = this.datepipe.transform(dtt.setDate(day + i), 'yyyy-MM-dd')

              if (x.leave_type_id == 3) {
                if (x?.shortLeave_hours) {
                  this.paid_short_leave_totalHours += Number(x?.shortLeave_hours);
                  this.paid_short_leave_numberOfDays += 1;
                  this.paidLeavesHalf.push(str);
                }
                else {
                  this.paidLeavesHalf.push(str);
                }
              } else {
                this.paidLeaves.push(str)
              }

            }
          } else {
            if (x.leave_type_id == 3) {
              if (x?.shortLeave_hours) {
                this.paid_short_leave_totalHours += Number(x?.shortLeave_hours);
                this.paid_short_leave_numberOfDays += 1;
                this.paidLeavesHalf.push(x.start_date);

              } else {
                this.paidLeavesHalf.push(x.start_date);
              }
            } else {
              this.paidLeaves.push(x.start_date)
            }

          }
        }
        else if (x.leave_payment_status == "unpaid") {
          if ((x.start_date != null || x.start_date.length > 0) && (x.end_date != null || x.end_date.length > 0)) {
            var dtt = new Date(x.start_date)
            var day = dtt.getDate()
            var totalDays = this.calculateDiff(x.start_date, x.end_date)
            for (let i = 0; i < totalDays; i++) {
              var str = this.datepipe.transform(dtt.setDate(day + i), 'yyyy-MM-dd')
              if (x.leave_type_id == 3) {
                if (x?.shortLeave_hours) {
                  this.unpaid_short_leave_totalHours += Number(x?.shortLeave_hours);
                  this.unpaid_short_leave_numberOfDays += 1; // Need too remove this +1 , and make it dynamic , from current day Total hours
                  this.unpaidLeavesHalf.push(str);
                }
                else {
                  this.unpaidLeavesHalf.push(str);
                  this.unpaid_short_leave_totalHours += 4;
                }
              } else {
                this.unpaidLeaves.push(str)
                this.unpaid_short_leave_totalHours += 4;
              }
            }
          } else {
            if (x.leave_type_id == 3) {
              if (x?.shortLeave_hours) {
                this.unpaid_short_leave_totalHours += Number(x?.shortLeave_hours);
                this.unpaid_short_leave_numberOfDays += 1;
                this.unpaidLeavesHalf.push(x.start_date);
              } else {
                this.unpaidLeavesHalf.push(x.start_date);
                this.unpaid_short_leave_totalHours += 4;
              }
            } else {
              this.unpaidLeaves.push(x.start_date)
              this.unpaid_short_leave_totalHours += 4;
            }

          }
        }
      }
    });
  }



  calculateDiff(data_1: any, data_2: any) {
    const date1 = new Date(data_1);
    const date2 = new Date(data_2);
    const days = Math.floor(
      (date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24
    );
    return days + 1;
  }
  genrateSalary() {
    
    if (this.isSalaryGenrated) {
      return
    }
    this.showSpinner = true;
    if (this.user_detail?.salary_type === "hourly") {
      console.log(this.user_detail?.salary_type);

      let totalWorkedHours = 0;
      let totalDayCount = 0;

      this.attandance_list.forEach((attendance: any) => {
        totalDayCount += 1;

        // Make sure total_hours is numeric
        const workingHours = parseFloat(attendance.total_hours || 0);
        totalWorkedHours += workingHours;
      });

      // Number of days in the selected salary month
      const totalDaysInMonth = parseInt(
        this.datepipe.transform(
          new Date(this.salary_month_year, this.salary_month_int, 0),
          'dd'
        )!
      );

      // Calculate salary
      const basicSalaryMonthyTax = 0; // You disabled auto-tax
      const basicSalary = this.user_detail.basic_salary * totalWorkedHours;

      // Deduction handling
      let totalDeduction = 0;
      if (this.active_loan != null) {
        totalDeduction = parseInt(this.active_loan_installment_amount);
      }

      const releasedSalary = basicSalary - totalDeduction;

      // Final details
      this.salary_detail.released_salary = Math.round(releasedSalary);
      this.salary_detail.total_worked_hours = totalWorkedHours;
      this.salary_detail.total_days_in_month = totalDaysInMonth;
    } else {
      console.log(this.user_detail?.salary_type);
      this.setUpLeaves()
      let worked_time = 0;
      let total_short_time = 0;
      let overtime = 0;
      let check_in_missed = 0;
      let check_in_late = 0;
      const paidLeaves = this.paidLeaves.length;
      const paidLeavesHalf = (this.paidLeavesHalf.length) / 2;
      let unPaidLeaves = this.unpaidLeaves.length;
      const unPaidLeavesHalf = this.unpaidLeavesHalf.length;
      let absents = 0;
      let toal_day_count = 0;
      this.attandance_list.forEach((attendace: any) => {
        toal_day_count += 1;
        const checkin = attendace.data[0].check_in ?? ''
        const checkout = attendace.data[0].check_out ?? ''
        const workingHours = attendace.total_hours
        const date = attendace.data[0].date
        this.latestShiftoffday = attendace.data[0].off_day
        const leaveCheckDate = date.replace(new RegExp('/', 'g'), '-')
        const dateOBJ = new Date(date);
        if (attendace.data[0].overtime != 0 && attendace.data[0].overtime > 0) {
          overtime += attendace.data[0].overtime
        }
        if (this.user_detail.last_working_date < leaveCheckDate) {
          //  OFF DAY (Sunday)
          unPaidLeaves += 1
        } else if (this.user_detail.joining_date > leaveCheckDate) {
          //  OFF DAY (Sunday)
          unPaidLeaves += 1
        } else if (dateOBJ.getDay() == 0
          && checkin.length == 0
          && checkout.length == 0
          && this.latestShiftoffday == null
        ) {
          //  OFF DAY (Sunday)
        } else if (this.dashboardService.otherOffDays.includes(date)) {
          // OFF DAY
        } else if (dateOBJ.getDay() == 6
          && checkin.length == 0
          && checkout.length == 0
          && this.latestShiftoffday == null) {
          //  OFF DAY (Saturday) Farhan (Just need to add extra id check for othhers )
        } else if (this.paidLeaves.includes(leaveCheckDate)) {
          //  Paid Leave (Approved)
        } else if (this.paidLeavesHalf.includes(leaveCheckDate)) {
          //  Half Paid Leave (Approved)
        } else if (this.unpaidLeaves.includes(leaveCheckDate)) {
          //  Un Paid Leave (Approved)
        } else if (this.unpaidLeavesHalf.includes(leaveCheckDate)) {
          //  Un Paid Leave Hald (Approved)
        } else if (checkin.length == 0 && checkout.length == 0 && this.latestShiftoffday != 1) {
          // Absent
          absents += 1;
        } else if (this.latestShiftoffday == 1
          && (checkin ?? '').length == 0
          && (checkout ?? '').length == 0) {
          //  Paid Leave (Approved)
        } else if (this.latestShiftoffday == 1
          && (checkin ?? '').length > 0
          && (checkout ?? '').length > 0) {
       
          
        } else {
          let perDayWorkingHour = 0;
          if (attendace.data[0].source == 'Tracker') {
            perDayWorkingHour = ((attendace.data[0].total_working_hours == null) ? this.user_detail.total_working_hours : attendace.data[0].total_working_hours) - 1;

          } else {
            perDayWorkingHour = (attendace.data[0].total_working_hours == null) ? this.user_detail.total_working_hours : attendace.data[0].total_working_hours;
          }

          worked_time += workingHours;
          if (checkin.length == 0) {
            //Check in Miss
            check_in_missed += 1;
            total_short_time += 4;
          }
          if (checkout.length == 0) {
            //Check Out Miss
            total_short_time += 4;
          }
          if (workingHours > 0 && workingHours < perDayWorkingHour) {
            //Short Time
            const shrtH = Number((perDayWorkingHour - workingHours).toFixed(2));
            total_short_time += shrtH;
          }
          // if(this.user_detail.attandance_type != "BD_Open"){  //Jawad : No needd for this check now we are calculation it dynamically
          const initialTime = (attendace.data[0].shift_start_time == null) ? this.user_detail.shift_start_time : attendace.data[0].shift_start_time;
          const startTimeLimit = calculateUpdatedTime(initialTime);
          if (checkin > startTimeLimit) {
            //Check In Late
            check_in_late += this.dashboardService.getLateCheckInTime(checkin, this.selected_user_id);
          }
          // }
        }
      });
      const total_day = parseInt(this.datepipe.transform(new Date(this.salary_month_year, this.salary_month_int, 0), 'dd')!);
      if (toal_day_count != total_day) {
        unPaidLeaves += total_day - toal_day_count
      }
      const basicSalaryMonthyTax = 0;// Remove auto genrated Tax => this.user_detail.monthly_tax_amount
      const basicSalary = this.user_detail.basic_salary;
      const dailySalary = (basicSalary * 12) / 365;
      const hourlySalary = dailySalary / 8;
      let unPaidLeavesAmount = (dailySalary * unPaidLeaves) * 1.0;

      // if (unPaidLeavesHalf > 0) {
      //   unPaidLeavesAmount = unPaidLeavesAmount + ((dailySalary * (unPaidLeavesHalf / 2)) * 1.0);
      // }
      if (this.unpaid_short_leave_numberOfDays > 0) {
        // deduct amount from total salary below
        this.unpaid_short_leave_salary_deduction = this.unpaid_short_leave_totalHours * hourlySalary;
        unPaidLeavesAmount = unPaidLeavesAmount + this.unpaid_short_leave_salary_deduction;
      }

      //Overtime Calculation
      const overTimeAmount = (overtime * hourlySalary) * 1.5

      // ------------------
      const AbsentAmount = (dailySalary * absents) * 1.5
      const lateCheckInAmmount = (hourlySalary * check_in_late) * 1.3
      let shortTimeAmmount = 0;
      if (this.selected_user_id == 161 || this.selected_user_id == 174) {
        // Nabeel Case + Masood Case
        shortTimeAmmount = (hourlySalary * total_short_time) * 1.0
      } else {
        shortTimeAmmount = (hourlySalary * total_short_time) * 1.2
      }



      let totalDeduction = basicSalaryMonthyTax + unPaidLeavesAmount + AbsentAmount + lateCheckInAmmount + shortTimeAmmount

      if (this.user_detail_openSalary == 1) {
        totalDeduction = 0;
      }

      if (this.active_loan != null) {
        totalDeduction = totalDeduction + parseInt(this.active_loan_installment_amount)
      }
      const releasedSalary = basicSalary - totalDeduction + overTimeAmount

      //Final Details
      this.salary_detail.paid_leaves = paidLeaves + paidLeavesHalf;
      this.salary_detail.unpaid_leaves = (unPaidLeaves + (this.unpaid_short_leave_totalHours / 8)); // Need to check
      this.salary_detail.short_hours = total_short_time;
      this.salary_detail.late_check_in = check_in_late;
      this.salary_detail.absents = absents;
      this.salary_detail.overtime_hours = overtime;
      this.salary_detail.overtime_amount = Math.round(overTimeAmount);
      this.salary_detail.unpaid_leaves_amount = Math.round(unPaidLeavesAmount);
      this.salary_detail.absents_amount = Math.round(AbsentAmount);
      this.salary_detail.late_check_in_amount = Math.round(lateCheckInAmmount);
      this.salary_detail.short_hours_amount = Math.round(shortTimeAmmount);
      this.salary_detail.total_deduction = Math.round(totalDeduction);
      this.salary_detail.released_salary = Math.round(releasedSalary);
    }
    this.showSpinner = false;
    this.isSalaryGenrated = true
  }

  updateSalary() {
    let advance_payment: number = parseFloat((document.getElementById("advance_payment") as HTMLInputElement).value);
    let comensation_amount: number = parseFloat((document.getElementById("compensation_amount") as HTMLInputElement).value);
    let other_deduction: number = parseFloat((document.getElementById("other_duduction") as HTMLInputElement).value);
    let calculated_tax: number = parseFloat((document.getElementById("tax_amount") as HTMLInputElement).value);

    advance_payment = isNaN(advance_payment) ? 0 : advance_payment;
    comensation_amount = isNaN(comensation_amount) ? 0 : comensation_amount;
    other_deduction = isNaN(other_deduction) ? 0 : other_deduction;
    calculated_tax = isNaN(calculated_tax) ? 0 : calculated_tax;

    if (advance_payment == null) {
      advance_payment = 0
    }

    if (comensation_amount == null) {
      comensation_amount = 0
    }

    if (other_deduction == null) {
      other_deduction = 0
    }
    if (calculated_tax == null) {
      calculated_tax = 0
    }
    let basicSalary = 0;

    if (this.user_detail.salary_type === 'hourly') {
      basicSalary = (this.salary_detail.basic_salary) * (this.salary_detail.total_worked_hours);
    } else {
      basicSalary = this.user_detail.basic_salary;
    }
    const totalDeduction = this.salary_detail.total_deduction + advance_payment + other_deduction + calculated_tax - comensation_amount
    const releasedSalary = (basicSalary - totalDeduction) + this.salary_detail.overtime_amount
    this.salary_detail.tax = calculated_tax
    this.salary_detail.advance_payment = advance_payment
    this.salary_detail.compensation_amount = comensation_amount
    this.salary_detail.other_deduction = other_deduction
    this.salary_detail.total_deduction = Math.round(totalDeduction)
    this.salary_detail.released_salary = Math.round(releasedSalary);
  }
  isdraft() {
    if (this.salary_detail.status == "draft") {
      return true
    }
    return false
  }
  isNotdraft() {
    if (this.salary_detail.status != "draft") {
      return true
    }
    return false
  }

  isActiveLoan() {
    if (this.active_loan != null || this.salary_detail.loan_deduction_amount != null) {
      return true
    }
    return false
  }
  user_detail_mode() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }

  

}
